var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 67,
    viewBox: "0 0 62 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_1126)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M31.9603 66.92C48.3521 66.92 61.6403 53.6318 61.6403 37.24C61.6403 20.8482 48.3521 7.56 31.9603 7.56C15.5685 7.56 2.28027 20.8482 2.28027 37.24C2.28027 53.6318 15.5685 66.92 31.9603 66.92Z",
    fill: "url(#paint0_radial_13_1126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "url(#paint1_linear_13_1126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4702 39.01V25.73H30.9002L31.7402 20.24H26.4702V16.67C26.4702 15.17 27.2102 13.7 29.5702 13.7H31.9702V9.01999C31.9702 9.01999 29.7902 8.64999 27.7202 8.64999C23.3802 8.64999 20.5402 11.28 20.5402 16.04V20.23H15.7002V25.72H20.5302V39H26.4702V39.01Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_13_1126",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.9612 37.2408) scale(29.6844 29.6844)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2482,
    stopColor: "#4C4C89",
    stopOpacity: 0.7518
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5193,
    stopColor: "#9898BB",
    stopOpacity: 0.4807
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744,
    stopColor: "#D0D0E0",
    stopOpacity: 0.256
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9103,
    stopColor: "#F2F2F6",
    stopOpacity: 0.0897
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13_1126",
    x1: 7.0299,
    y1: 7.0299,
    x2: 40.9731,
    y2: 40.9731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1677F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1756,
    stopColor: "#186EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4613,
    stopColor: "#1E56D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8194,
    stopColor: "#262EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B189C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_1126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.65,
    height: 66.93,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2);
export default __webpack_public_path__ + "static/media/frame-2.571ac60410ec7d846c976af9e447bbac.svg";
export { ForwardRef as ReactComponent };